<template>
  <el-dialog :visible.sync="visible" :title="submitForm.teacherName+'授课班级设置'" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.className" placeholder="班级名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="this.dataList" border  @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">

      <el-table-column  header-align="center" align="center" >
        <template slot-scope="scope" >
        <el-button v-if="isInArray(scope.row.id)"  size="mini" @click="setInspector(scope.row)">选中</el-button>
        <el-button v-else=""  type="danger" size="mini" @click="removeInspector(scope.row)">移除所教班级</el-button>
           </template></el-table-column>
      <el-table-column prop="className" label="班级名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="headTeacherName" label="班主任" header-align="center" align="center"></el-table-column>
      <el-table-column prop="courseName" label="课程名称" header-align="center" align="center">
        <template slot-scope="scope">
        <el-tag
                v-for="course in scope.row.courseNameList"
                :key="course.courseId">
          {{course.courseName}}
        </el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope">
        <el-button v-if="$hasPermission('teacher:course:config') && isInCourse(scope.row.id)" type="text" size="small"
                   @click="teacherCourseConfig(scope)">课程设置
        </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <teacher-course-add v-if="teacherCourseConfigVisible" ref="teacherCourseAdd" @refreshDataList="getDataList()"></teacher-course-add>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import mixinViewModule from '@/mixins/view-module'
import TeacherCourseAdd from './teacher-course-add'
export default {
  name: 'teacher-class-config',
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classmanage/classmanage/page',
        getDataListIsPage: true,
        exportURL: '/classmanage/classmanage/export',
        deleteURL: '/classmanage/classmanage',
        deleteIsBatch: true
      },
      visible: false,
      teacherCourseConfigVisible: false,
      dataForm: {
        teacherName: '',
        classId: '',
        className: '',
        schoolId: ''
      },
      teacherClassList: [],
      submitForm: {
        id: '',
        teacherId: '',
        teacherName: '',
        classId: '',
        className: '',
        classList: []
      },
      inspectorList: [],
      dataList: [],
      checkedCourses: []
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        // this.getDataList()
        this.query()
        this.getTeacherClass()
        // this.getCheckCourse()
      })
    },
    query () {
      const url = `/classmanage/classmanage/page?teacherId=${this.submitForm.teacherId}`
      this.dataListLoading = true
      this.$http.get(
        url,
        {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            ...this.dataForm
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        console.log('dataList',res)
        this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    /*  getCheckCourse () {
      //console.log(id)
      //console.log(this.submitForm)
      this.$http.get('/teachercourse/teachercourse/page',{
        params: {
          classId: '',
          teacherId: this.submitForm.teacherId
        }
      } ).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.checkedCourses = res.data.list
        //console.log(this.checkedCourses)
      }).catch(() => {})
    },

    isTeacher (id){
      console.log(id)
      //console.log(this.checkedCourses[0].teacherId)

      for(var i = 0; i < this.checkedCourses.length; i++){
        if(id === this.checkedCourses[i].classId && this.submitForm.teacherId === this.checkedCourses[i].teacherId){
          return true;
        }
        else {
          return false;

        }
      }
    }, */
    teacherCourseConfig (scope) {
      this.teacherCourseConfigVisible = true
      /* console.log("-------------------------------")
      console.log(scope)
      console.log("-------------------------------") */
      this.$nextTick(() => {
        // this.$refs.teacherCourseAdd.submitForm.teacherId = scope.row.id
        this.$refs.teacherCourseAdd.dataForm.classId = scope.row.id
        this.$refs.teacherCourseAdd.dataForm.teacherId = this.submitForm.teacherId
        this.$refs.teacherCourseAdd.dataForm.className = scope.row.className
        this.$refs.teacherCourseAdd.dataForm.teacherName = this.submitForm.teacherName
        this.$refs.teacherCourseAdd.submitForm.classId = scope.row.id
        this.$refs.teacherCourseAdd.submitForm.teacherId = this.submitForm.teacherId
        this.$refs.teacherCourseAdd.submitForm.className = scope.row.className
        this.$refs.teacherCourseAdd.submitForm.teacherName = this.submitForm.teacherName
        this.$refs.teacherCourseAdd.init()
      })
    },
    isInArray (id) {
      for (var i = 0; i < this.teacherClassList.length; i++) {
        if (id === this.teacherClassList[i].classId) {
          return false
        }
      }
      return true
    },
    isInCourse (id) {
      for (var i = 0; i < this.teacherClassList.length; i++) {
        if (id === this.teacherClassList[i].classId) {
          return true
        }
      }
      return false
    },
    getTeacherClass () {
      this.$http.get('/teacher/teacherClassConfig/viewTeachingClassList', {
        params: {
          teacherId: this.submitForm.teacherId,
          classId: this.submitForm.classId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.teacherClassList = res.data
        this.isInArray()
        console.log(this.teacherClassList)
      }).catch(() => {})
    },
    removeInspector (row) {
      console.log(row)
      this.$http.get('/teacher/teacherClassConfig/removeClassTeacher', {
        params: {
          classId: row.id,
          teacherId: this.submitForm.teacherId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$notify({
          type: 'info',
          duration: '750',
          message: '授课班级移除成功'
        })
      })
    },

    /**
     * 设置教师班级
     */
    setInspector (row) {
      // 组装参数
      this.submitForm.classId = row.id
      this.submitForm.className = row.className
      this.$http.post('/teacher/teacherClassConfig', this.submitForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()

        this.$emit('refreshDataList')

        this.$notify({
          type: 'success',
          duration: '750',
          message: '授课班级设置成功'
        })
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.submitForm.classList = this.dataListSelections

      this.$http.post('/teacher/teacherClassConfig/teacherClassConfig', this.submitForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }, 1000, { leading: true, trailing: false })
  },
  components: {
    TeacherCourseAdd
  }

}
</script>
